import React from 'react';
import s from './divider.module.scss';
var Divider = function Divider() {
  return /*#__PURE__*/React.createElement("span", {
    className: s.btn
  });
};
export default Divider;